<script>
import { mapMutations } from 'vuex';
import { MDBBtn } from "mdb-vue-ui-kit";
import clientConfig from '/src/config/client.js';

export default {
  data () {
    return {
      clientConfig
    };
  },
  components: {
    MDBBtn
  },
  methods: {
    ...mapMutations([
      'goToPage',
    ])
  }
}
</script>

<template>
  <footer class='ahc-lifetime-footer'>
    <div class='ahc-lifetime-footer_logos'>
      <img
        :src="require('@/assets/' + clientConfig.content.welcome.logoUrl + '')"
        class='ahc-lifetime-footer_lifetime-logo'
        alt="Company footer logo"
      />
      <div class='ahc-lifetime-footer_powered-by d-none d-sm-block'>
        Built by Gallagher © {{ new Date().getFullYear() }}
      </div>
    </div>
    <div class="ahc-lifetime-footer_links">
      <div class='ahc-lifetime-footer_powered-by d-block d-sm-none'>
        Built by Gallagher © {{ new Date().getFullYear() }}
      </div>
      <MDBBtn @click="goToPage('disclaimer-and-assumptions')" class="disclaimer-link">
        Disclaimer and Assumptions
      </MDBBtn>
    </div>
  </footer>
</template>
